/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { SignupAttributionRequest } from './signupAttributionRequest';

export interface RegisterRequest {
  email: string;
  /**
     * @minLength 8
     * @maxLength 128
     */
  password: string;
  /** @maxLength 100 */
  first_name?: string;
  /** @maxLength 100 */
  last_name?: string;
  invitation_token?: string | null;
  attribution?: SignupAttributionRequest | null;
  fingerprint_event_id?: string | null;
}
